import { Button, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import CenterContent from "../layouts/CenterContent";

const StyledCenterContent = styled(CenterContent)`
  padding: ${p => p.theme.padding}px;
  color: ${p => p.theme.colorText};
  background-color: ${p => p.theme.colorWarning};
`;

const StyledSpace = styled(Space).attrs({ direction: "vertical", align: "center", size: "large" })`
  flex: 1 1 auto;
  justify-content: center;
`;

const ButtonContainer = styled.div`
  flex: 0 0 auto;
  padding: ${p => p.theme.paddingLG}px;
  text-align: center;
`;

const StyledLinkButton = styled(Button).attrs({ type: "link" })`
  color: ${p => p.theme.colorText};
`;

const StyledImage = styled.img`
  width: 256px;
  height: 256px;
`;

const { Title } = Typography;

interface AppConflictScreenProps {
  onRefresh(): void;
  onSwitchAccount(): void;
}

export default function AppConflictScreen({ onRefresh, onSwitchAccount }: AppConflictScreenProps) {
  const { t } = useTranslation();

  return (
    <StyledCenterContent>
      <StyledSpace>
        <Title level={2} style={{ margin: 0 }}>{t("appConflictScreen.title")}</Title>
        <Title level={4} style={{ margin: 0 }}>{t("appConflictScreen.description")}</Title>
        <StyledImage src="/img/app-conflict.png" alt="" />
        <Button type="default" onClick={onRefresh}>{t("errorHandling.refreshPage")}</Button>
      </StyledSpace>
      <ButtonContainer>
        <StyledLinkButton onClick={onSwitchAccount}>{t("appConflictScreen.switchAccount")}</StyledLinkButton>
      </ButtonContainer>
    </StyledCenterContent>
  );
}
